import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ status: null, refresh: () => {} });
export const useMaintenance = () => useContext(Ctx);

const PREVIEW_KEY = "cm_preview_token";
const readPreview = () => {
  try {
    const q = new URLSearchParams(window.location.search).get("preview");
    if (q) sessionStorage.setItem(PREVIEW_KEY, q);
    return sessionStorage.getItem(PREVIEW_KEY) || "";
  } catch (e) { return ""; }
};

export const MaintenanceProvider = ({ children }) => {
  const [status, setStatus] = useState(undefined);
  const [preview] = useState(readPreview);

  const refresh = useCallback(() => api.get("/maintenance/status", { params: preview ? { preview } : {} })
    .then((r) => setStatus(r.data && typeof r.data === "object" ? r.data : null))
    .catch(() => setStatus((s) => (s === undefined ? null : s))), [preview]);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 60000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [refresh]);

  useEffect(() => {
    const marks = [status?.ends_at, status?.upcoming?.start].filter(Boolean).map((d) => new Date(d).getTime() - Date.now()).filter((ms) => ms > 0 && ms < 86400000);
    if (!marks.length) return undefined;
    const t = setTimeout(refresh, Math.min(...marks) + 1500);
    return () => clearTimeout(t);
  }, [status, refresh]);

  return <Ctx.Provider value={{ status, refresh, preview }}>{children}</Ctx.Provider>;
};
